// extracted by mini-css-extract-plugin
export default {"Frame":"_3DView_Frame__TJz7l"};